// Nodes modules
import './modules/@tc';
import 'classlist-polyfill';
import 'object-fit-polyfill';
import {disablePageScroll, enablePageScroll} from '@fluejs/noscroll';


window.addEventListener('load', function(){
    // GENERAL
    var body = document.body;
    var mainHeader = document.querySelector('.main-header');

    function checkScroll() {
        //const scroll = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
        const scroll = document.querySelector('.dialog-off-canvas-main-canvas').scrollTop;
        
        if (scroll > 20) {
            mainHeader.classList.add('scrolled');
        } else {
            mainHeader.classList.remove('scrolled');
        }
    }
    
      
    const container = document.querySelector('.dialog-off-canvas-main-canvas');
    container.addEventListener('scroll', checkScroll);
    

    // PARRALAX
    const circles = document.querySelectorAll('.circle');
    const specialCircles = document.querySelectorAll('.special-circle');

    let currentScroll = 0;
    let targetScroll = 0;

    // --- PARALLAX FLUIDE ---
    function animateParallax() {
    currentScroll += (targetScroll - currentScroll) * 0.1;

    circles.forEach((circle, i) => {
        const speed = (i + 1) * 0.05; // vitesses différentes
        const direction = i % 2 === 0 ? -1 : 1; // optionnel : inversion alternée
        const translateY = currentScroll * speed * direction;

        // Si le cercle est visible, on applique aussi la translation
        if (circle.classList.contains('visible')) {
        circle.style.transform = `translateY(${translateY}px) scale(1)`;
        } else {
        circle.style.transform = `translateY(${translateY}px) scale(0)`;
        }
    });

    specialCircles.forEach((specialCircles, i) => {
        const speed = (i + 0.003) * 0.003; // vitesses différentes
        const direction = i % 2 === 0 ? 1 : -1; // optionnel : inversion alternée
        const translateY = currentScroll * speed * direction;

        specialCircles.style.transform = `translateY(${translateY}px)`;
    });

    requestAnimationFrame(animateParallax);
    }

    window.addEventListener('scroll', () => {
    targetScroll = window.scrollY;
    });

    animateParallax();

    // --- APPARITION SCALE (IntersectionObserver) ---
    const observer = new IntersectionObserver(
    entries => {
        entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('visible');
        }
        });
    },
    { threshold: 0.5 } // déclenche quand 50% du cercle est visible
    );

    circles.forEach(circle => observer.observe(circle));


    // BIG-MENU
    var serviceBtn = document.querySelector("header .nav .nav-item-expanded a");
    var menuBox = document.querySelector('header .services-bigmenu');
    var blackShade = document.querySelector(".black-shade");

    function menuOpenUpdate() {
        //menuBox.style.display = "block";
        blackShade.style.zIndex = "9997";
        blackShade.style.opacity = "1";
    }

    function menuCloseUpdate() {
        //menuBox.style.display = "none";
        blackShade.style.zIndex = "-1";
        blackShade.style.opacity = "0";
        //menuBox.style.display = "none";
    }

    function toggleBigMenu() {
        body.classList.toggle("bigmenu-open");
    }

    serviceBtn.onclick = function(e) {
        e.preventDefault();

        toggleBigMenu();

        if (body.classList.contains('bigmenu-open')) {
            //menuTimeline.play();
            menuOpenUpdate();
        } else {
            //menuTimeline.reverse(-1);
            menuCloseUpdate();
        }
    };

    blackShade.onclick = function() {
        body.classList.remove("bigmenu-open");
        //menuTimeline.reverse(-1);
        blackShade.style.zIndex = "-1";
        menuCloseUpdate();
    };

    // BURGER-MENU
    var burgerBtn = document.querySelector("header .burger-wrapper");

    function toggleMobilMenu() {
        body.classList.toggle("mobilmenu-open");
    }

    burgerBtn.onclick = function(e) {
        e.preventDefault();
        toggleMobilMenu();

        if (body.classList.contains('mobilmenu-open')) {
            //disablePageScroll();
            //body.style.overflowY = "hidden";
        } else {
            //enablePageScroll();
            //body.style.overflowY = "scroll";
        }
    };

    // FAQ
    const accordionHeaders = document.querySelectorAll(".accordion-header");

    accordionHeaders.forEach(header => {
        header.addEventListener("click", () => {
            const activeHeader = document.querySelector(".accordion-header.active");
            
            // Fermer l'item actif s'il existe et n'est pas le même
            if (activeHeader && activeHeader !== header) {
                activeHeader.classList.remove("active");
                activeHeader.nextElementSibling.style.maxHeight = 0;
            }

            // Basculer l'item cliqué
            header.classList.toggle("active");
            const content = header.nextElementSibling;
            
            if (header.classList.contains("active")) {
                content.style.maxHeight = content.scrollHeight + 20 + "px";
            } else {
                content.style.maxHeight = 0;
            }
        });
    });

    function adjustRoundedCutFooterMargin() {
        const footerWrapper = document.querySelector('.rounded-cut.--footer');
        if (!footerWrapper) {
            //console.warn('.rounded-cut.--footer introuvable');
            return;
        }

        const path = footerWrapper.querySelector('path');
        if (!path) {
            //console.warn('path introuvable dans .rounded-cut.--footer');
            return;
        }

        // hauteur du wrapper
        const wrapperHeight = footerWrapper.getBoundingClientRect().height;

        // bbox du path en unités SVG
        const bbox = path.getBBox();

        // hauteur réelle du SVG à l'écran
        const svg = path.ownerSVGElement;
        const svgRect = svg.getBoundingClientRect();

        // conversion du path en pixels CSS
        const scaleY = svgRect.height / svg.viewBox.baseVal.height;
        const pathHeightPixels = bbox.height * scaleY;

        // différence pour le footer
        const diff = wrapperHeight - pathHeightPixels;

        // appliquer margin-top négatif sur le wrapper
        if (window.innerWidth >= 1400) {
            footerWrapper.style.marginTop = `-${diff + 175 }px`;
        } else if (window.innerWidth >= 992 && window.innerWidth <= 1399) {
            footerWrapper.style.marginTop = `-${diff + 160}px`;
        } else {
            footerWrapper.style.marginTop = '';
        }

        // appliquer margin-top négatif sur toutes les .col dans .footer-top : hauteur du path + 50px
        const cols = document.querySelectorAll('.footer-top .col');
        cols.forEach(col => {
            if (window.innerWidth >= 992) {
                col.style.marginTop = `-${pathHeightPixels + 50}px`;
            } else if (window.innerWidth >= 768 && window.innerWidth <= 991) {
                col.style.marginTop = `-${pathHeightPixels + 20}px`;
            } else {
                col.style.marginTop = '';
            }
        });

        // appliquer margin-top sur le footer : hauteur du path + 150px
        const footerFAQ = document.querySelector('footer.--faq');
        if (footerFAQ) {
            if (window.innerWidth >= 1200) {
                footerFAQ.style.marginTop = `${pathHeightPixels + 260}px`;
            } else if (window.innerWidth >= 992 && window.innerWidth <= 1199) {
                footerFAQ.style.marginTop = `${pathHeightPixels + 220}px`;
            } else {
                footerFAQ.style.marginTop = '';
            }
        }

        const footerNotFAQ = document.querySelector('footer:not(.--faq)');
        if (footerNotFAQ) {
            if (window.innerWidth >= 992) {
                footerNotFAQ.style.marginTop = `${pathHeightPixels + 260}px`;
            } else {
                footerNotFAQ.style.marginTop = '';
            }
        }

        // appliquer margin-top sur .--faq .footer-middle si elle existe : 100px - hauteur du path
        const faqMiddle = document.querySelector('.--faq .footer-middle');
        if (faqMiddle) {
            if (window.innerWidth >= 1400) {
                faqMiddle.style.paddingTop = `${125 - pathHeightPixels}px`;
            } else if (window.innerWidth >= 768 && window.innerWidth <= 1399) {
                faqMiddle.style.paddingTop = `${75 - pathHeightPixels}px`;
            } else {
                faqMiddle.style.paddingTop = '';
            }
        }

        // appliquer margin-bottom sur .bloc-pro si elle existe : 150px + hauteur du wrapper
        const blocPro = document.querySelector('.bloc-pro');
        if (blocPro) {
            if (window.innerWidth >= 1600) {
                // au-dessus de 1600px
                blocPro.style.paddingTop = `${150 - pathHeightPixels}px`;
            } else if (window.innerWidth >= 992 && window.innerWidth <= 1599) {
                // entre 768px et 1599px
                blocPro.style.paddingTop = `${100 - pathHeightPixels}px`;
            } else {
                blocPro.style.paddingTop = '';
            }
        }

        // appliquer margin-top négatif sur .rounded-cut .--bloc-pro si elle existe : hauteur du wrapper
        const roundedBlocPro = document.querySelector('.rounded-cut.--bloc-pro');
        if (roundedBlocPro) {
            roundedBlocPro.style.marginTop = `-${wrapperHeight}px`;
        }

        // appliquer margin-bottom sur .bloc-consultations si elle existe : 150px + hauteur du wrapper
        const blocConsult = document.querySelector('.homepage-content .bloc-consultations');
        if (blocConsult) {
            if (window.innerWidth >= 1600) {
                // au-dessus de 1600px
                blocConsult.style.paddingTop = `${150 - pathHeightPixels}px`;
                blocConsult.style.paddingBottom = `${150 + pathHeightPixels}px`;
            } else if (window.innerWidth >= 991 && window.innerWidth <= 1599) {
                // entre 768px et 1599px
                blocConsult.style.paddingTop = `${100 - pathHeightPixels}px`;
                blocConsult.style.paddingBottom = `${100 + pathHeightPixels}px`;
            } else {
                blocConsult.style.paddingTop = '';
                blocConsult.style.paddingBottom = '';
            }
        }

        // appliquer margin-top négatif sur .rounded-cut.--bloc-consultations si elle existe : 150px + hauteur du wrapper
        const roundedBlocConsult = document.querySelector('.rounded-cut.--bloc-consultations');
        if (roundedBlocConsult) {
            if (window.innerWidth < 1850) {
                roundedBlocConsult.style.marginTop = `-${wrapperHeight}px`;
            } else {
                roundedBlocConsult.style.marginTop = `-${240 + pathHeightPixels}px`;
            }
        }

        // appliquer top sur header en fonction de la hauteur de la barre de notification en mobil
        const notificationBar = document.querySelector('.notification-bar');
        const notificationBarHeight = notificationBar.getBoundingClientRect().height;
        //const headerHeight = mainHeader.getBoundingClientRect().height;
        //console.log(headerHeight);

        if (notificationBar && mainHeader) {
            if (window.innerWidth < 992) {
                mainHeader.style.top = notificationBarHeight + 'px';
            } else {
                mainHeader.style.top = 'auto';
            }
        }

        // appliquer un margin-top sur le content en fonction de la hauteur de la barre de notif + header en mobil
        const basicPageJumbotron = document.querySelector('.basic-page-jumbotron');

        if (basicPageJumbotron) {
            if (window.innerWidth < 992) {
                //basicPageJumbotron.style.marginTop = notificationBarHeight + 'px';
                basicPageJumbotron.style.marginTop = '0px';
            } else {
                basicPageJumbotron.style.marginTop = '';
            }
        }

        const homepageJumbotron = document.querySelector('.homepage-jumbotron');
        if (homepageJumbotron) {
            if (window.innerWidth < 992) {
                homepageJumbotron.style.marginTop = notificationBarHeight + 'px';
            } else {
                homepageJumbotron.style.marginTop = '';
            }
        }

        // appliquer un height sur menu en fonction de la hauteur du header
        
        const mobilMenu = document.getElementById("menu");

        if (mobilMenu) {
            if (window.innerWidth >= 992) {
                mobilMenu.style.height = 'auto';
            } else if (window.innerWidth >= 768 && window.innerWidth <= 991) {
                //mobilMenu.style.height = `calc(100vh - ${notificationBarHeight + 137}px)`;
            } else if (window.innerWidth >= 576 && window.innerWidth <= 767) {
                //mobilMenu.style.height = `calc(100vh - ${notificationBarHeight + 122}px)`;
            } else if (window.innerWidth < 576) {
                //mobilMenu.style.height = `calc(100vh - ${notificationBarHeight + 92}px)`;
            }
        }
        
        /*
        console.log('Hauteur wrapper :', wrapperHeight, 'px');
        console.log('Hauteur path :', pathHeightPixels, 'px');
        console.log('Différence footer / margin-top appliqué :', diff, 'px');
        */
    }

    // exécution initiale
    adjustRoundedCutFooterMargin();

    // recalcul au resize pour rester responsive
    window.addEventListener('resize', adjustRoundedCutFooterMargin);


    // remove bigmenu et mobilmenu open on resize
    function adjustMenuOpen() {
        //console.log('fack off');

        if (window.innerWidth <= 992) {
            if (body.classList.contains('bigmenu-open')) {
                body.classList.remove("bigmenu-open");
                blackShade.style.zIndex = "-1";
                menuCloseUpdate();
            }
        }

        if (window.innerWidth >= 992) {
            if (body.classList.contains('mobilmenu-open')) {
                enablePageScroll();
                //body.style.overflowY = "scroll";
                body.classList.remove("mobilmenu-open");
            }
        }
    }

    window.addEventListener('resize', adjustMenuOpen);
});

